module.exports = __webpack_public_path__ + "static/media/shuwu.581e941f.png";